export default "__VITE_ASSET__CH0CD8Lx__"